import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import {
  runReport,
  setReportDateRange,
  setReportLoading,
  setReportData,
} from "../../../Redux/Actions/reportActions";
import RechargeReportDist from "../../Cards/Reports/DistributorReports/RechargeReportDist/RechargeReportDist";
import { BASE_API_URL } from "../../../Utils/constants";

class RechargeReportPageDist extends Component {
  async componentDidMount() {
    const { reportSettings } = this.props;
    try {
      this.props.setReportLoading(true);
      await this.props.runReport(
        `${BASE_API_URL}/distributor/reports/recharge-report`,
        reportSettings.selectedStartDate,
        reportSettings.selectedEndDate
      );
      this.props.setReportLoading(false);
    } catch (error) {
      this.props.setReportLoading(false);
    }
  }

  componentWillUnmount() {
    const NOW = moment().format("MM/DD/YYYY");
    this.props.setReportDateRange(NOW, NOW);
    this.props.setReportData([]);
  }

  render() {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <RechargeReportDist />
        </Grid>
      </Grid>
    );
  }
}

RechargeReportPageDist.propTypes = {
  runReport: PropTypes.func.isRequired,
  setReportDateRange: PropTypes.func.isRequired,
  reportSettings: PropTypes.object.isRequired,
  setReportLoading: PropTypes.func.isRequired,
  setReportData: PropTypes.func.isRequired,
};

RechargeReportPageDist.defaultProps = {
  reportSettings: {},
};

function mapStateToProps(state) {
  return {
    reportSettings: state.reportSettings,
  };
}

export default connect(mapStateToProps, {
  runReport,
  setReportDateRange,
  setReportLoading,
  setReportData,
})(RechargeReportPageDist);
